import React, { useState } from 'react';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isRegisterMode, setIsRegisterMode] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim() || !password.trim() || (isRegisterMode && !username.trim())) {
      setError('Please fill in all required fields.');
      return;
    }

    setIsLoading(true);

    try {
      if (isRegisterMode) {
        // 🔥 REGISTER PAYLOAD
        const payload = {
          username: username.trim(),
          email: email.trim(),
          password: password.trim(),
        };

        const res = await fetch(
          `https://api.securxperts.com:8000/auth/signup`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
          }
        );

        const data = await res.json();
        if (res.ok) {
          alert("Account created Successfully. Please login.");
          setIsRegisterMode(false);
          setUsername('');
          setEmail('');
          setPassword('');
        } else {
          setError(data.detail || data.message || "Registration failed.");
        }

      } else {
        // 🔥 LOGIN PAYLOAD
        const payload = {
          email: email.trim(),
          password: password.trim(),
          device_details: "Unknown Device",
        };

        const res = await fetch(
          "https://api.securxperts.com:8000/auth/login",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
          }
        );

        const data = await res.json();
        if (res.ok && data.access_token) {
          sessionStorage.setItem("loggedInUser", "true");
          sessionStorage.setItem("access_token", data.access_token);
          sessionStorage.setItem("token_type", data.token_type);
          sessionStorage.setItem("email", email.trim());
          window.location.href = "/laura_dashboard";
        } else {
          setError(data.detail || data.message || "Invalid email or password.");
        }
      }
    } catch {
      setError("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, #6e8efb, #a777e3)',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: "'Poppins', sans-serif"
    }}>
      <style jsx global>{`
        .login-container {
          display: flex;
          align-items: center;
          background: #fff;
          padding: 30px;
          border-radius: 12px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
          max-width: 900px;
          width: 100%;
        }
        .login-image {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .login-image img {
          max-width: 100%;
          border-radius: 10px;
        }
        .login-form {
          flex: 1;
          padding: 20px;
        }
        .form-control {
          border-radius: 30px;
          padding: 12px;
        }
        .btn-primary {
          background: linear-gradient(90deg, #4e54c8, #8f94fb);
          border: none;
          padding: 12px;
          border-radius: 30px;
          font-weight: bold;
          transition: 0.3s;
        }
        .btn-primary:hover {
          background: linear-gradient(90deg, #8f94fb, #4e54c8);
          transform: scale(1.05);
        }
        .switch-link {
          color: #4e54c8;
          font-weight: bold;
          cursor: pointer;
        }
      `}</style>

      <div className="login-container">
        <div className="login-image">
          <img alt="Login Illustration" src="img/login.svg" />
        </div>

        <div className="login-form">
          <h3 style={{ textAlign: 'center', marginBottom: '15px' }}>
            {isRegisterMode ? "Create Account" : "HR Login"}
          </h3>

          {error && <p className="text-danger text-center">{error}</p>}

          <form onSubmit={handleSubmit}>
            {isRegisterMode && (
              <div className="mb-3">
                <label className="form-label" htmlFor="username">Username</label>
                <input
                  id="username"
                  name="username"
                  className="form-control"
                  placeholder="Enter username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
            )}

            <div className="mb-3">
              <label className="form-label" htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                className="form-control"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label" htmlFor="password">Password</label>
              <input
                id="password"
                name="password"
                className="form-control"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button className="btn btn-primary w-100" type="submit" disabled={isLoading}>
              {isLoading ? "Please wait..." : isRegisterMode ? "Register" : "Login"}
            </button>
          </form>

          <p className="text-center mt-3">
            {isRegisterMode ? (
              <>
                Already have an account?{" "}
                <span className="switch-link" onClick={() => setIsRegisterMode(false)}>
                  Login
                </span>
              </>
            ) : (
              <>
                Don’t have an account?{" "}
                <span className="switch-link" onClick={() => setIsRegisterMode(true)}>
                  Register
                </span>
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
